import React from 'react';
import classNames from "classnames";

export default class Well extends React.Component
{
    render()
    {
        const classes = classNames(
            this.props.className,
            "bg-gray-200 text-gray-700 overflow-hidden rounded-lg",
        );

        return <div {...this.props} className={classes}>
            <div className="px-4 py-5 sm:p-6">
                { this.props.children }
            </div>
        </div>;
    }
}
